import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { UserState } from "../../../store/reducers/userReducer";
import { MenuState } from "../../../store/reducers/menuReducer";
import { RootState } from "../../../store/index";
import HHSolicitationsTable from "../../../components/Data/HHSolicitationsTable"
import LcInfiniteTable from "../../../components/Data/LcInfiniteTable"
import Layout from "../../../components/Layout/Layout";
import CreateNewSolicitation from "../../Solicitations/CreateNewSolicitation";
import SideModal from "../../../components/Layout/SideModal/SideModal";
import LcIcon from "../../../components/Generic/LcIcon";
import SolicitationService from "../../../services/SolicitationService/SolicitationService";
import { SolicitationTemplate } from "../../../models/SolicitationTemplate";
import { SolicitationFilter } from "../../../models/SolicitationFilter";
import { SolicitationView } from "../../../models/SolicitationView";
import moment from "moment";
import { useDebounce } from "use-debounce";
import SolicitationCommentService from "../../../services/SolicitationCommentService/SolicitationCommentService";
import { OptionsTooltips } from "../../../models/OptionsTooltips";
import LcIconLink, { Size, Position } from "../../../components/Generic/LcIconLink";
import SolicitationDetails from "./SolicitationDetails";
import sanitizeHtml from "sanitize-html";
import "./index.css";
import LcLoading from "../../../components/Generic/LcLoading";
import StatusColorDisplay from "../../../components/Generic/StatusColorDisplay";
import { DialogContent, DialogContentText, Dialog } from "@mui/material";
import { PrefState } from "../../../store/reducers/prefReducer";
import DynamicTableGroupColumnManagerService from "../../../services/DynamicTableGroupAndColumnBuilder/DynamicTableGroupAndColumnBuilder"
import { Field } from "../../../models/Field";
import { Period } from "../../../models/Period";

const SolicitatonsList: React.FC = (props) => {
    const pref = useSelector<RootState, PrefState>(state => state.pref);
    const user = useSelector<RootState, UserState>(state => state.user);
    const menu = useSelector<RootState, MenuState>(state => state.menu);
    const dispatch = useDispatch();
    const groupService = new DynamicTableGroupColumnManagerService();
    const [solicitationService] = useState<SolicitationService>(new SolicitationService(props));
    const [solicitationCommentService] = useState<SolicitationCommentService>(new SolicitationCommentService(props));
    const [solicitations, setSolicitations] = useState<SolicitationView[]>([]);
    const [filteredSolicitations, setFilteredSolicitations] = useState<SolicitationView[]>([]);
    const [refresh, setRefresh] = useState(false);
    const [filterDefault, setFilterDefault] = useState<{ size: number, term: string, column: string, direction: string }>({ size: 20, term: "", column: "", direction: "asc" });
    const [filter, setFilter] = useState<{ size: number, term: string, column: string, direction: string }>(filterDefault);
    const [solicitationType, setSolicitationType] = useState<string>((pref.data?.SolicitationType != null) ? pref.data?.SolicitationType + "" : "all");
    const [selectedSolicitation, setSelectedSolicitation] = useState<SolicitationView[]>([]);
    const [showCreateSolicitation, setShowCreateSolicitation] = useState<boolean>(false);
    const [showAttendant, setShowAttendant] = useState<number>(0);
    const [sizeScreen, setSizeScreen] = useState<number>(0);
    const [templateList, setTemplateList] = useState<SolicitationTemplate[]>([]);
    const [templateSelections, setTemplateSelections] = useState<Period[]>([]);
    const [loadNewCall, setLoadNewCall] = useState<boolean>(false);
    const dateTimeNow = new Date();
    const momentDateTimeNow = moment(dateTimeNow.toISOString());
    const [solicitationList, setSolicitationList] = useState<Period[]>([]);
    const [isLoadingSolicitation, setIsLoadingSolicitation] = useState<boolean>(true);
    const [modalVisibleDetails, setModalVisibleDetails] = useState<boolean>(false);
    const [detailsRow, setDetailsRow] = useState<any>();
    const [modalVisibleEditTemplates, setModalVisibleEditTemplates] = useState<boolean>(false);
    const [modalVisibleMoreTemplates, setModalVisibleMoreTemplates] = useState<boolean>(false);
    const [loadingTemplate, setLoadingTemplate] = useState<boolean>(false);
    const [selectedRowId, setSelectedRowId] = useState<any>();
    const [duplicateRow, setDuplicateRow] = useState<any>(undefined);
    const [templateSelected, setTemplateSelected] = useState<any>(undefined);
    const [openPopUp, setOpenPopUp] = useState<boolean>(window.screen.width < 600)
    const [search, setSearch] = useState<string>("");
    const [searchDebounce] = useDebounce(search, 500);
    const [solicitationTypeDebounce] = useDebounce(solicitationType, 700);
    const [pendingEvaluation, setPendingEvaluation] = useState<any>(undefined);
    const [tabMobile, setTabMobile] = useState<number>(1);
    const [selectedRadioRows, setSelectedRadioRows] = useState<any[]>([]);
    const [openModalPref, setOpenModalPref] = useState<boolean>(false);
    const [windowWidth, setWindowWidth] = useState<number>(0);
    const [flagEmail, setFlagEmail] = useState<boolean>(true);
    const onClickOption = (checklist: Field[]) => setSelectedOptions(checklist);

    const options: Field[] = [
        { label: "Número", name: "number", value: true },
        { label: "Assunto", name: "subject", value: true },
        { label: "Detalhamento", name: "detailing", value: false },
        { label: "Comentário ou anexo", name: "comment/file", value: false },
        { label: "Conclusão", name: "conclusion", value: false },
        { label: "Campos de formulário", name: "formCamp", value: false },
    ];

    const [selectedOptions, setSelectedOptions] = useState<Field[]>(options);

    const rowHelper = [
        {
            idStatus: 1,
            id: 123456,
            registrationDate: new Date(),
            attendant: "",
            subject: "teste assunto"
        },
        {
            idStatus: 2,
            id: 123457,
            registrationDate: new Date(),
            attendant: "",
            subject: "teste assunto 2"
        }
    ];

    useEffect(() => {
        setOpenModalPref(pref.dataLocal?.openModalPref ?? false);
    }, [pref.dataLocal?.openModalPref])

    useEffect(() => {
        if (menu.showHelper) {
            setSelectedRadioRows([...selectedRadioRows, rowHelper[0]]);
        }
    }, [menu.showHelper])

    const optionsSanitize = {
        allowedTags: [],
        allowedAttributes: {}
    }

    const templateDefault: Period = {
        label: "",
        text: "",
        fields: [{
            name: "",
            value: ""
        }]
    };

    const getFilter = () => {
        return {
            userId: user.id,
            customerId: "0",
            idTeam: "0",
            attendantId: "0",
            idStatus: "111",
            incidentId: "0",
            IdsGroupService: "0",
            IdsService: "0",
            dataInicio: "0",
            dataFinal: "0",
            TipoData: "-1",
            TipoSearch: "-1",
            Search: "-1",
            Top: "200",
            solicitationGroup: "0",
        }
    }

    const getSolicitationsType = () => {
        const _solicitationType = pref.data?.SolicitationType;

        if (solicitationType) {
            getSolicitations(solicitationType);
        }
        else {
            _solicitationType && setSolicitationType(_solicitationType);
            getSolicitations(_solicitationType);
        }
    }

    useEffect(() => {
        getSolicitationsType();
    }, [solicitationTypeDebounce]);

    useEffect(() => {
        setSolicitationType((pref.data?.SolicitationType && pref.data?.SolicitationType.toString()) ?? "all");
    }, [pref.data?.SolicitationType])

    useEffect(() => {
        if (search === "") {
            clearSolicitationList();
        }
    }, [search])

    useEffect(() => {
        let queryParam = window.location.search.split("?id=");
        if (queryParam.length > 1 && filteredSolicitations.length > 0 && flagEmail) {
            let row = solicitations.filter(row => row.id === parseInt(queryParam[1]))
            setDetailsRow(row[0]);
            setModalVisibleDetails(true)
            setFlagEmail(false)
        }
    }, [solicitations])

    useEffect(() => {
        if (!menu.showHelper) {
            if (searchDebounce !== "") {
                let filterDefaultLocal = solicitationTypeFilter(getFilter(), solicitationType);
                filterDefaultLocal = {
                    ...filterDefaultLocal,
                    Search: searchDebounce,
                    idStatus: "111",
                    Top: "10"
                }

                let tipoPesquisa = "";

                const checkedNumero = selectedOptions.find(x => x.name === "number");
                const checkedAssunto = selectedOptions.find(x => x.name === "subject");
                // const checkedDetalhamento = selectedOptions.find(x => x.name == "detailing");
                // const checkedComentario = selectedOptions.find(x => x.name == "comment/file");
                // const checkedConclusao = selectedOptions.find(x => x.name == "conclusion");
                // const checkedForm = selectedOptions.find(x => x.name == "formCamp");

                if (checkedNumero?.value === true) {
                    tipoPesquisa += "number ";
                }

                if (checkedAssunto?.value === true) {
                    tipoPesquisa += "subject ";
                }

                getSolicitationsDebounce(filterDefaultLocal);
            }
            else {
                clearSolicitationList();
            }
        }
    }, [searchDebounce])

    const getSolicitationsDebounce = async (filterDefault) => {
        setIsLoadingSolicitation(true);

        try {
            const solicitationResponse = await solicitationService.retrieveSolicitationsbyFilter(filterDefault as SolicitationFilter);
            let solicitationListB: Period[] = [];

            solicitationResponse.data.map((solicitation: any) => {

                let solicitationList_ = templateDefault;

                if (solicitation.details === null) {
                    solicitation.details = "";
                }

                const detailsLenght = solicitation.details.length;

                const details = (detailsLenght <= 300) ? solicitation.details : solicitation.details.substring(0, 300) + " (...)";
                const labelId = (window.screen.width > 600) ? "> " + solicitation.id + " - " : "";

                solicitationList_ = {
                    label: labelId + solicitation.subject + " - " + details,
                    text: solicitation.subject,
                    fields: [
                        {
                            name: solicitation.subject,
                            value: solicitation.id.toString()
                        }
                    ],
                    record: solicitation
                }

                solicitationListB.push(solicitationList_);
            })

            setSolicitationList(solicitationListB);
        }
        catch (error) {
            console.warn(error)
        }

        setRefresh(true);
        setIsLoadingSolicitation(false)
        setRefresh(false);
    }

    const getSolicitationsMoreLines = async (filterDefault) => {
        setRefresh(true);

        // setFilteredSolicitations([]);
        try {
            const solicitationResponse = await solicitationService.retrieveSolicitationsbyFilter(filterDefault as SolicitationFilter);
            setFilteredSolicitations(solicitationResponse.data);
        }
        catch (error) {
            console.warn(error)
        }

        setRefresh(false);
    }

    const solicitationTypeFilter = (filter: any, solicitationTypeLocal: string) => {
        if (solicitationTypeLocal === "active") {
            filter = { ...filter, idStatus: "100" };
        }
        else if (solicitationTypeLocal === "today") {

            const dataInicial = moment(dateTimeNow).format("YYYY-MM-DD");
            const dateFinal = moment(dateTimeNow).add(1, "day").format("YYYY-MM-DD");

            filter = { ...filter, dataInicio: dataInicial, dataFinal: dateFinal, TipoData: "0" };
        }
        else if (solicitationTypeLocal === "week") {

            const dataInicial = moment(dateTimeNow).day(0).format("YYYY-MM-DD");
            const dateFinal = moment(dateTimeNow).day(6).format("YYYY-MM-DD");

            filter = { ...filter, dataInicio: dataInicial, dataFinal: dateFinal, TipoData: "0" };
        }
        else if (solicitationTypeLocal === "month") {

            const dateFirstDay = new Date(dateTimeNow.getFullYear(), dateTimeNow.getMonth(), 1);
            const dataInicial = moment(dateFirstDay).format("YYYY-MM-DD");
            const dateFinal = moment(dataInicial).add(1, "month").format("YYYY-MM-DD");

            filter = { ...filter, dataInicio: dataInicial, dataFinal: dateFinal, TipoData: "0", idStatus: "111" };
        }
        else if (solicitationTypeLocal === "lastMonth") {

            const dataInicial = moment(dateTimeNow).subtract(1, "months").startOf("month").format("YYYY-MM-DD");
            const dateFinal = moment(dateTimeNow).subtract(1, "months").endOf("month").format("YYYY-MM-DD");
            filter = { ...filter, dataInicio: dataInicial, dataFinal: dateFinal, TipoData: "0" };
        }
        else if (solicitationTypeLocal === "lastSixMonths") {
            const dataInicial = moment(dateTimeNow).subtract(6, "months").format("YYYY-MM-DD");
            const dateFinal = moment(dateTimeNow).format("YYYY-MM-DD");
            filter = { ...filter, dataInicio: dataInicial, dataFinal: dateFinal, TipoData: "0" };
        }
        else if (solicitationTypeLocal === "lastTwelveMonths") {
            const dataInicial = moment(dateTimeNow).subtract(12, "months").format("YYYY-MM-DD");
            const dateFinal = moment(dateTimeNow).format("YYYY-MM-DD");
            filter = { ...filter, dataInicio: dataInicial, dataFinal: dateFinal, TipoData: "0" };
        }
        else if (solicitationTypeLocal === "lastYear") {
            const dataInicial = moment(dateTimeNow).subtract(1, "year").startOf("year").format("YYYY-MM-DD");
            const dateFinal = moment(dateTimeNow).subtract(1, "year").endOf("year").format("YYYY-MM-DD");
            filter = { ...filter, dataInicio: dataInicial, dataFinal: dateFinal, TipoData: "0" };
        }
        else if (solicitationTypeLocal === "closed") {
            filter = { ...filter, idStatus: "7_8" };
        }
        else if (solicitationTypeLocal === "all") {
            filter = { ...filter, idStatus: "111" };
        }
        else if (solicitationTypeLocal === "waitingEvaluation") {
            filter = { ...filter, idStatus: "8" };
        }
        else if (solicitationTypeLocal === "solicitationGroup") {
            filter = { ...filter, solicitationGroup: "1" };
        }
        else if (solicitationTypeLocal === "canceled") {
            filter = { ...filter, idStatus: "6" };
        }
        return filter;
    }

    useEffect(() => {
        var filtered = solicitations.
            sort((a: any, b: any) => {
                if (filter.direction === "asc") return (a[filter.column] > b[filter.column]) ? 1 : -1;
                else return (a[filter.column] > b[filter.column]) ? -1 : 1;
            });

        setFilteredSolicitations(filtered);

    }, [filter]);

    const getSolicitations = async (solicitationType) => {
        getTemplates();
        setFilteredSolicitations([]);
        setRefresh(true);

        let filterDefault = {
            ...getFilter()
        };

        filterDefault = solicitationTypeFilter(filterDefault, solicitationType);

        var max = (user.businessAreas && Math.max.apply(null, user.businessAreas.map(c => c.showAttendant))) || 0;
        setShowAttendant(max);

        try {
            const solicitationResponse = await solicitationService.retrieveSolicitationsbyFilter(filterDefault as SolicitationFilter);
            let closedSolicitations = solicitationResponse.data.filter(x => x.idStatus === 8 && x.satisfactionSurveyRespond !== 1);
            closedSolicitations = closedSolicitations.sort((a: any, b: any) => (a.id < b.id ? 1 : -1));
            setSolicitations(solicitationResponse.data);
            setFilteredSolicitations((pref.data?.SolicitationType === "waitingEvaluation")
                ? closedSolicitations
                : solicitationResponse.data
            );
            penddingEvaluation(closedSolicitations);
        }
        catch (error) {
            console.warn(error)
        }

        setRefresh(false);
    }

    const penddingEvaluation = (closedSolicitations: SolicitationView[]) => {
        let flagRating = sessionStorage.getItem("autenticated");

        if (closedSolicitations.length > 0 && window.location.search === "" && flagRating === "true" && window.screen.width > 600) {
            setPendingEvaluation(closedSolicitations[0]);

            setTimeout(() => {
                handleOpenDetails(closedSolicitations[0]);
            }, 800);
        }

        sessionStorage.setItem("autenticated", "false");
    }

    // useEffect(() => {

    //     if (pendingEvaluation !== undefined && flagRating === "true" && window.screen.width > 600) {
    //         sessionStorage.setItem("autenticated", "false")
    //     }
    // }, [pendingEvaluation]);

    useEffect(() => {
        setSelectedSolicitation(selectedRadioRows);
    }, [selectedRadioRows]);

    const getTemplates = async () => {

        try {
            const solicitationResponse = await solicitationService.getSolicitationTemplates(Number(user.id));
            let templates: Period[] = [];

            solicitationResponse.data.map((solicitation: any) => {
                let template_ = templateDefault;

                template_ = {
                    label: solicitation.name,
                    text: solicitation.name,
                    fields: [
                        {
                            name: solicitation.name,
                            value: solicitation.id.toString()
                        }
                    ]
                }

                templates.push(template_);
            })

            setTemplateSelections(templates);
            setTemplateList(solicitationResponse.data);
        }
        catch (error) {
            console.warn(error);
        }
    }

    const getSearch = (search: string) => setSearch(search);

    const onChageSelectionTemplate = (selected: any) => {
        if (selected.label === "mais") {
            setModalVisibleMoreTemplates(false);
            setModalVisibleEditTemplates(true);
        }
        else if (selected.label === "edit") {
            setModalVisibleEditTemplates(false);
            setModalVisibleMoreTemplates(true);
        }
        else {
            const templateCall = templateList.find(temp => temp.id === parseInt(selected.fields[0].value));
            setTemplateSelected(templateCall);
            setShowCreateSolicitation(true)
            setLoadNewCall(true);
            // setModalVisible(true);
        }
    }

    const onChangeSelectionSolicitation = (selection: any) => {

        if (selection.fields[0].value === "mais") {
            //let filtered: SolicitationView[] = [];

            //solicitationList.map(selection => {
            //    let temp = solicitations.find(x => x.id.toString() == selection.fields[0].value);

            //    if (temp != undefined) filtered.push(temp);
            //})
            let filterDefaultLocal = { ...getFilter() };
            filterDefaultLocal = solicitationTypeFilter(getFilter(), solicitationType);
            filterDefaultLocal = {
                ...filterDefaultLocal,
                Search: search,
                idStatus: "111",
                Top: "100"
            }

            const checkedNumero = selectedOptions.find(x => x.name === "number");
            const checkedAssunto = selectedOptions.find(x => x.name === "subject");

            let tipoPesquisa = "";

            if (checkedNumero?.value === true) {
                tipoPesquisa += "number ";
            }

            if (checkedAssunto?.value === true) {
                tipoPesquisa += "subject ";
            }

            getSolicitationsMoreLines(filterDefaultLocal);

        }
        else {
            setModalVisibleDetails(true);
            setDetailsRow(selection.record);
        }
    }

    const clearSolicitationList = () => {
        setSolicitationList([]);
        setFilteredSolicitations(solicitations);
    }

    const testeList = [
        {
            label: "> 123456 - <strong>teste</strong> assunto - <strong>teste</strong> detalhes",
        },
        {
            label: "> 123457 - <strong>teste</strong> assunto 2 - detalhes",
        },
    ]

    const functionGeneric = [
        {
            title: "Novo chamado",
            icon: "ppi ppi-plus",
            tooltip: "Novo chamado",
            hide: false,
            func: () => {
                setLoadNewCall(true);
                setShowCreateSolicitation(true);
            }
        },
        {
            title: "Novo chamado com template",
            icon: "ppi ppi-chevron-down-alt",
            tooltip: "Templates de chamados",
            size: "tiny" as Size,
            tooltipPosition: "fullRight" as Position,
            isSelection: true,
            hide: window.screen.width < 600,
            selection: {
                contents: templateSelections,
                onChange: onChageSelectionTemplate
            }
        },
        {
            title: "Duplicar chamado",
            icon: "ppi ppi-duplicate",
            hide: window.screen.width < 600,
            iconDisabled: {
                color: "#B5B7C6",
                tooltip: "Selecione um chamado para ser duplicado"
            },
            tooltip: "Duplicar chamado",
            func: () => {

                if (selectedSolicitation.length > 0) {
                    setTemplateSelected(selectedSolicitation[0]);

                    setSelectedSolicitation([]);
                    setLoadNewCall(true);
                    setShowCreateSolicitation(true);
                }
            }
        },
        {
            title: "Filtro",
            icon: "ppi ppi-search",
            isFilter: true,
            hide: false,
            isFilterCampo: {
                isLoadingContents: isLoadingSolicitation,
                contents: (menu.showHelper) ? testeList : solicitationList,
                onChange: onChangeSelectionSolicitation,
                onChangePesquisa: getSearch,
                dropDownOptions: options,
                onClickOption: onClickOption
            }
        },
        {
            title: "Atualizar",
            icon: "ppi ppi-refresh",
            tooltip: "Atualizar",
            hide: false,
            func: () => {
                getSolicitations(solicitationType);
                handleReload();
            }
        }
    ];

    const handleHidden = (row: any, isOnSelectedRowsRadio: any) => {
        if (isOnSelectedRowsRadio && row.id === isOnSelectedRowsRadio.id) {
            return false;
        }
        else if (selectedRowId === undefined) {
            return true;
        }
        else if (row.id !== selectedRowId) {
            return true;
        }
        else {
            return false;
        }
    }

    const handleSelectedRowId = (rowId: any) => {
        setSelectedRowId(rowId);
    }

    const getHeaderAtenddantName = () => {
        switch (showAttendant) {
            case 1: return "Atendente";
            case 2: return "Equipe";
            default: return "";
        }
    }

    // const getWidthColumns = (field: string) => {
    //     let fieldSubjext = document.getElementById("frameList")?.clientWidth;

    //     if (fieldSubjext) {
    //         const field1 = 35;
    //         const field2 = 215;
    //         const field3 = fieldSubjext && fieldSubjext > 800 ? 100 : 150;
    //         const field4 = 120;
    //         const field5 = !(showAttendant >= 1) ? 0 : 200;

    //         switch (field) {
    //             case "": return field1;
    //             case "status": return field2 + "px";
    //             case "id": return field3 + "px";
    //             case "registrationDate": return field4 + "px";
    //             case "attendant": return field5 + "px";
    //             case "subject": {
    //                 let size_: number = 800;

    //                 // fieldSubjext > 1200 ? size_ = 800 : fieldSubjext > 900 ? size_ = 600 : size_ = 350
    //                 const screenSize = (windowWidth == 0) ? fieldSubjext : windowWidth;
    //                 size_ = screenSize - (field1 * 3) - field2 - field4 - field5;

    //                 return size_ + "px";
    //             }
    //         }
    //     }
    // }

    const columns = [
        {
            field: " ",
            headerName: " ",
            // width: getWidthColumns(""),
            width: "2.5%",
            overflow: "visible",
            align: "center",
            sort: false,
            renderCell: (row: any) => {
                let isOnSelectedRowsRadio = (selectedRadioRows)
                    ? selectedRadioRows.find((r: any) => r.id === row.id)
                    : undefined;

                return (
                    <div style={{ display: "flex" }}>
                        <div
                            className={"selectable"}
                            hidden={handleHidden(row, isOnSelectedRowsRadio)}
                            style={{
                                display: (handleHidden(row, isOnSelectedRowsRadio)) ? "none" : "flex",
                                alignItems: "center",
                                flexDirection: "row",
                                flexWrap: "wrap",
                                margin: "0px 10px",
                            }}
                            onClick={() => {
                                let rows: any[] = [];

                                if (isOnSelectedRowsRadio) {
                                    let removeRow = selectedRadioRows.find((r: any) => r.id !== row.id);
                                    setSelectedRadioRows(removeRow);
                                }
                                else {
                                    rows.push(row)
                                    setSelectedRadioRows(rows)
                                }
                            }}
                        >
                            <i className={`ppi ppi-radiobtn${isOnSelectedRowsRadio ? "-on " : " "}`} />
                        </div>
                    </div>
                )
            }
        },
        {
            field: " ",
            headerName: " ",
            // width: getWidthColumns(""),
            width: "2.5%",
            align: "left",
            sort: false,
            renderCell: (row: any) => {
                let diferencaMes = 0;
                if (row.closingDate) diferencaMes = momentDateTimeNow.diff(moment(row.closingDate), "months");

                return (
                    <>
                        {
                            row.idStatus === 8 && diferencaMes < 1 &&
                            <LcIcon icon={row.satisfactionSurveyRespond !== 1 ? "ppi ppi-star" : "ppi ppi-star-solid"} color={"#777777"} />
                        }
                    </>

                )
            }
        },
        {
            field: " ",
            headerName: " ",
            // width: getWidthColumns(""),
            width: "2.5%",
            align: "left",
            sort: false,
            renderCell: (row: any) => {
                return (
                    <>
                        {
                            row.solicitationGroupId !== "0" &&
                            <LcIcon icon="ppi ppi-user-group" size={"small"} />
                        }
                    </>
                )
            }
        },
        {
            field: "idStatus",
            headerName: "Situação",
            // width: getWidthColumns("status"),
            width: "15%",
            align: "left",
            renderCell: (row: any) => {
                return <StatusColorDisplay row={row} type={"solicitation"} />
            }
        },
        {
            field: "id",
            headerName: "Número",
            // width: getWidthColumns("id"),
            width: "9%",
            align: "left",
        },
        {
            field: "subject",
            headerName: "Assunto",
            // width: getWidthColumns("subject"),
            width: (showAttendant != 0) ? "38.5%" : "57.5%",
            align: "left",
            overflow: "visible",
            trigger: "hover",
            class: "subject",
            renderCell: (row: any) => {
                return <span style={{ textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap", display: "block" }}>{row.subject}</span>
            }
        },
        {
            field: "registrationDate",
            headerName: "Data / Hora",
            // width: getWidthColumns("registrationDate"),
            width: "11%",
            align: "left",
            renderCell: (row: any) => {
                const time = new Date(row.registrationDate).toLocaleTimeString().slice(0, -3);
                const momentDateTimeNow = moment();

                const registrationMoment = moment(row.registrationDate);
                const isSameDayAsNow = momentDateTimeNow.isSame(registrationMoment, "day");
                const isSameMonthAsNow = momentDateTimeNow.isSame(registrationMoment, "month");
                const isSameYearAsNow = momentDateTimeNow.isSame(registrationMoment, "year");

                let data;

                if (isSameDayAsNow) {
                    data = time;
                }
                else if (isSameMonthAsNow && isSameYearAsNow) {
                    data = registrationMoment.fromNow();
                }
                else {
                    const diffInMonths = momentDateTimeNow.diff(registrationMoment, "months", true);

                    if (diffInMonths >= 1.0) {
                        const monthsAgo = Math.floor(diffInMonths);
                        data = `há ${monthsAgo} ${monthsAgo === 1 ? "mês" : "meses"}`;
                    }
                    else {
                        data = registrationMoment.fromNow();
                    }
                }

                return <span>{data}</span>;
            }
        },
        {
            field: "attendant",
            headerName: getHeaderAtenddantName(),
            // width: getWidthColumns("attendant"),
            width: (showAttendant != 0) ? "19%" : "0%",
            align: "left",
            hide: !(showAttendant >= 1),
            renderCell: (row: any) => {
                return (
                    <>
                        {
                            showAttendant !== 0 &&
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    flexWrap: "nowrap",
                                    alignItems: "center",
                                }}
                            >
                                <LcIcon icon={(row.attendant == null) ? "ppi ppi-clock" : "ppi ppi-user"} size="small" color={(row.attendant == null) ? "#898DA6" : "#141B4D"} />
                                <span style={{ marginTop: "4px" }}> {(row.attendant == null) ? "" : row.attendant} </span>
                            </div>
                        }
                    </>
                )
            }
        }
    ];

    const handleOpenDetails = (row: any) => {
        setDetailsRow(row);
        setTabMobile(1);
        setModalVisibleDetails(true);
    }

    const onChageSelection = (selected: any) => {
        setSolicitationType(selected.fields[0].value);
        dispatch({ type: "PREF_UPDATE", payload: { name: "SolicitationType", value: selected.fields[0].value } });
    }

    useEffect(() => {
        const interval = setInterval(() => {
            getSolicitations(solicitationType);
        }, 600000);

        return () => clearInterval(interval);
    }, []);

    const selectionsList = [
        {
            label: "Todos os chamados",
            text: "Todos os chamados",
            default: (pref.data?.SolicitationType === "all" || !pref.data?.SolicitationType),
            fields: [{ name: "all", value: "all" }]
        },
        {
            label: "Chamados em aberto",
            text: "Chamados em aberto",
            default: (pref.data?.SolicitationType === "active"),
            fields: [{ name: "active", value: "active" }],
        },
        {
            label: "Chamados finalizados",
            text: "Chamados finalizados",
            default: (pref.data?.SolicitationType === "closed"),
            fields: [{ name: "closed", value: "closed" }],
        },
        {
            label: "Chamados cancelados",
            text: "Chamados cancelados",
            default: (pref.data?.SolicitationType === "canceled"),
            fields: [{ name: "canceled", value: "canceled" }],
        },
        {
            label: "Chamados de hoje",
            text: "Chamados de hoje",
            default: (pref.data?.SolicitationType === "today"),
            fields: [{ name: "today", value: "today" }]
        },
        {
            label: "Chamados da semana",
            text: "Chamados da semana",
            default: (pref.data?.SolicitationType === "week"),
            fields: [{ name: "week", value: "week" }]
        },
        {
            label: "Chamados deste mês",
            text: "Chamados deste mês",
            default: (pref.data?.SolicitationType === "month"),
            fields: [{ name: "month", value: "month" }]
        },
        {
            label: "Chamados do mês anterior",
            text: "Chamados do mês anterior",
            default: (pref.data?.SolicitationType === "lastMonth"),
            fields: [{ name: "lastMonth", value: "lastMonth" }]
        },
        {
            label: "Chamados dos últimos 6 meses",
            text: "Chamados dos últimos 6 meses",
            default: (pref.data?.SolicitationType === "lastSixMonths"),
            fields: [{ name: "lastSixMonths", value: "lastSixMonths" }]
        },
        {
            label: "Chamados dos últimos 12 meses",
            text: "Chamados dos últimos 12 meses",
            default: (pref.data?.SolicitationType === "lastTwelveMonths"),
            fields: [{ name: "lastTwelveMonths", value: "lastTwelveMonths" }]
        },
        {
            label: "Chamados do ano anterior",
            text: "Chamados do ano anterior",
            default: (pref.data?.SolicitationType === "lastYear"),
            fields: [{ name: "lastYear", value: "lastYear" }]
        },
        {
            label: "Chamados esperando avaliação",
            text: "Chamados esperando avaliação",
            default: (pref.data?.SolicitationType === "waitingEvaluation"),
            fields: [{ name: "waitingEvaluation", value: "waitingEvaluation" }]
        },
        {
            label: "Chamados grupo de solicitante",
            text: "Chamados grupo de solicitante",
            default: (pref.data?.SolicitationType === "solicitationGroup"),
            fields: [{ name: "solicitationGroup", value: "solicitationGroup" }]
        },
    ];

    const solicitationSelection = {
        selections: selectionsList,
        onChange: onChageSelection
    };

    const onSortChangeSolicitations = (sortData: any) => {
        const { sort, size } = sortData;
        setFilter({ ...filter, column: sort.column, direction: sort.direction, size: size })
    };

    useEffect(() => {
        if (filter !== filterDefault) {
            setFilterDefault(filter)
            setFilteredSolicitations([])
            setFilteredSolicitations(groupService.sortColumns(filteredSolicitations, filter))
        }

    }, [filter])

    const handleCloseReopen = () => {
        setRefresh(true);
    }

    // const [messageErrorGroup, setMessageErrorGroup] = useState<string>("");

    const handleReload = () => {
        // setMessageErrorGroup("");
        // getSolicitations(currentFilter);
        setRefresh(true);
    }

    const handleClose = () => {
        // setModalVisible(false);
        setShowCreateSolicitation(false)
        setLoadNewCall(false);
        setRefresh(true);
        setSelectedSolicitation([]);
        setDuplicateRow(undefined);
        setTemplateSelected(undefined);
        getSolicitations(solicitationType);
        //    getSolicitationsMoreLines({ ...getFilter() });
    }

    const handleCloseTemplates = () => {
        setModalVisibleEditTemplates(false);
    }

    const handleCloseTemplatesEdition = () => {
        setModalVisibleMoreTemplates(false);
    }

    const montaFields = (row: any) => {
        let statusDescription = solicitationService.statusList.find(x => x.value === row.idStatus.toString())?.label;

        var fields: { text: string, value: string, propText?: React.CSSProperties, propValue?: React.CSSProperties }[] = [];

        const chamadoValue: React.CSSProperties = { fontSize: "14px", position: "relative", top: "-22px", left: "75px", marginBottom: "-18px", width: "fit-content" };
        let chamado = { text: "Chamado", value: row.id.toString(), propValue: chamadoValue };

        const dataText: React.CSSProperties = { color: "#8B90A3", fontWeight: "600", fontSize: "12px" };

        const dataDia = moment(row.registrationDate).format("DD/MM");
        const dataHora = moment(row.registrationDate).format("HH:mm");
        let data = { text: "Data e hora", value: dataDia + " às " + dataHora, propText: dataText };

        let status = { text: "Status", value: (statusDescription) ? statusDescription : "", propText: dataText };

        fields = [chamado, data, status];

        return fields;
    }

    async function searchExpandedFields(solicitationId: number, setExpandedFieldsTooltip: any) {

        try {
            const response = await solicitationCommentService.getCommentsViewBySolicitation(solicitationId);
            let expandedFieldsTemp: { text: string, value: string }[] = [];

            response.data.map((comment: any) => {

                const commentLenght = comment.text.length;
                const commentText = (commentLenght <= 300) ? sanitizeHtml(comment.text, optionsSanitize) : sanitizeHtml(comment.text, optionsSanitize).substring(0, 300) + " (...)";

                let commentValue = moment(comment.commentDate).fromNow();
                commentValue = commentValue.charAt(0).toUpperCase() + commentValue.slice(1);
                let comentario = { text: commentText, value: commentValue };

                expandedFieldsTemp.push(comentario);
            });

            setExpandedFieldsTooltip(expandedFieldsTemp);
        }
        catch (error) {
            console.warn(error);
        }
    }

    const optionsProperties: OptionsTooltips = {
        delayHide: 20,
        delayShow: 1000,
        delayUpdate: 500,
        noOpacity: true,
        expandNoResults: "Sem comentários disponíveis",
        position: "Right",
        expandPosition: "Right",
    }

    const rowClick = {
        rowPointer: true,
        rowFunction: handleOpenDetails,
        rowSelected: detailsRow
    }

    const properties = {
        montaFields: montaFields,
        searchExpandedFields: searchExpandedFields,
        optionsProperties: optionsProperties
    }

    const handleHeaderDetails = () => {
        if (detailsRow !== undefined) {
            if (detailsRow.idStatus === 8 || detailsRow.idStatus === 7) {
                return `Avaliação do atendimento - ${detailsRow.id}`
            }

            return `${detailsRow.subject} - ${detailsRow.id}`
        }

        return ""
    }

    useEffect(() => {
        let divSize = document.getElementById("divSize");
        setSizeScreen((divSize?.clientWidth && divSize?.clientWidth + 30) || 0);
    }, [refresh])

    useEffect(() => {
        let divSize = document.getElementById("divSize");
        setSizeScreen((divSize?.clientWidth && divSize?.clientWidth + 30) || 0);

        function handleWindowResize() {
            setWindowWidth(document.getElementById("frameList")?.clientWidth ?? 0);
        }

        window.addEventListener("resize", handleWindowResize);

        return () => {
            window.removeEventListener("resize", handleWindowResize);
        };
    }, []);

    useEffect(() => {
        let size = (menu.toggle) ? sizeScreen + 180 : sizeScreen - 180;
        setSizeScreen(size);
    }, [menu]);

    const editTemplateColumns = [
        {
            field: "",
            headerName: "Copiar",
            width: "20%",
            overflow: "visible",
            align: "left",
            sort: false,
            renderCell: (row: any) => (
                <LcIconLink
                    icon={"ppi ppi-document-duplicate"}
                    onClick={() => handleClickCopy(row)}
                    tooltip={"Criar nova solicitação com base no template"}
                    tooltipPosition={"fullRight"}
                />
            )
        },
        {
            field: "name",
            headerName: "Descrição",
            width: "65%",
        },
        {
            field: "",
            headerName: "Excluir",
            width: "20%",
            align: "right",
            sort: false,
            overflow: "visible",
            renderCell: (row: any) => (
                <LcIconLink
                    icon={"ppi ppi-trash"}
                    tooltip={"Excluir template"}
                    onClick={() => handleClickDelete(row)}
                />
            )
        },
    ];

    const moreTemplateColumns = [
        {
            field: "",
            headerName: "Copiar",
            width: "15%",
            overflow: "visible",
            renderCell: (row: any) => (
                <LcIconLink
                    icon={"ppi ppi-document-duplicate"}
                    onClick={() => handleClickCopy(row)}
                    tooltip={"Criar nova solicitação com base no template"}
                    tooltipPosition={"fullRight"}
                />
            )
        },
        {
            field: "name",
            headerName: "Descrição",
            width: "85%",
        },
    ];

    const handleClickCopy = (row: any) => {
        const templateCall = templateList.find(temp => temp.id === row.id);

        setTemplateSelected(templateCall);

        setModalVisibleMoreTemplates(false);
        setModalVisibleEditTemplates(false);
        setLoadNewCall(true);
        setShowCreateSolicitation(true);
    }

    const handleClickDelete = async (row: any) => {
        setLoadingTemplate(true);

        try {
            await solicitationService.deleteSolicitationTemplate(Number(user.id), row.id);
            getTemplates();
        }
        catch (error) {
            console.warn(error);
        }

        setLoadingTemplate(false);
    }

    useEffect(() => {
        const openModalPropPref = pref.dataLocal?.openModalPropPref ?? false;

        if (openModalPropPref) {
            const detailsRowEx = {
                id: 123456789,
                nameBusinessArea: "Processor",
                nameServiceGroup: "Processor LiveCloud",
                nameService: "Security - Detection & Response",
                nameProcess: "Solicitação de Desbloqueio EDR",
                solicitationDate: new Date().toString(),
                nameCustomer: "PROCESSOR",
                urgency: 1,
                subject: "Solicitação teste",
                details: "Solicitação teste",
                idStatus: 1,
            } as unknown as SolicitationView;

            setDetailsRow(detailsRowEx);
            setModalVisibleDetails(true);
        }
        else {
            setDetailsRow(undefined);
            setModalVisibleDetails(false);
        }
    }, [pref.dataLocal?.openModalPropPref]);

    useEffect(() => {
        const openModalAvaliationPref = pref.dataLocal?.openModalPropPref ?? false;

        if (openModalAvaliationPref) {
            const detailsRowEx = {
                id: 123456789,
                nameBusinessArea: "Processor",
                nameServiceGroup: "Processor LiveCloud",
                nameService: "Security - Detection & Response",
                nameProcess: "Solicitação de Desbloqueio EDR",
                solicitationDate: new Date().toString(),
                nameCustomer: "PROCESSOR",
                urgency: 1,
                subject: "Solicitação teste",
                details: "Solicitação teste",
                idStatus: 8,
                satisfactionSurveyRespond: 0
            } as unknown as SolicitationView;

            setDetailsRow(detailsRowEx);
            setModalVisibleDetails(true);
        }
        else {
            setDetailsRow(undefined);
            setModalVisibleDetails(false);
        }
    }, [pref.dataLocal?.openModalAvaliationPref])

    useEffect(() => {
        setShowCreateSolicitation(false);
        setModalVisibleMoreTemplates(false);
        setModalVisibleEditTemplates(false);
        setModalVisibleDetails(false);
        setOpenPopUp(false);
    }, [menu.showHelper]);

    useEffect(() => {
        if (!modalVisibleDetails) {
            setDetailsRow(undefined);
        }
    }, [modalVisibleDetails]);

    return (
        <Layout selection={solicitationSelection}>
            <div id={"divSize"}>
                <HHSolicitationsTable
                    height={"calc(100% - 250px)"}
                    loading={refresh}
                    columns={columns}
                    rows={(menu.showHelper) ? rowHelper : filteredSolicitations}
                    functionGeneric={functionGeneric}
                    size={filteredSolicitations.length}
                    loadMore={() => { }}
                    onSortChange={onSortChangeSolicitations}
                    tootipProperties={properties}
                    rowClick={rowClick}
                    handleSelectedRowId={handleSelectedRowId}
                    selectedRadioRows={selectedRadioRows}
                    handleReload={true}
                />

                {
                    modalVisibleMoreTemplates &&
                    <SideModal header={"Templates de Chamados"} visible={modalVisibleMoreTemplates} onClose={() => handleCloseTemplatesEdition()}>
                        <LcLoading loading={loadingTemplate} label={"Carregando..."}>
                            <LcInfiniteTable
                                height={"calc(100% - 250px)"}
                                loading={loadingTemplate}
                                columns={editTemplateColumns}
                                rows={templateList}
                                size={templateList.length}
                                loadMore={() => { }}
                                onSortChange={onSortChangeSolicitations}
                                linked={false}
                            />
                        </LcLoading>
                    </SideModal>
                }
                {
                    modalVisibleEditTemplates &&
                    <SideModal header={"Mais templates"} visible={modalVisibleEditTemplates} onClose={() => handleCloseTemplates()}>
                        <LcLoading loading={loadingTemplate} label={"Carregando..."}>
                            <LcInfiniteTable
                                height={"calc(100% - 250px)"}
                                loading={loadingTemplate}
                                columns={moreTemplateColumns}
                                rows={templateList}
                                size={templateList.length}
                                loadMore={() => { }}
                                onSortChange={onSortChangeSolicitations}
                            />
                        </LcLoading>
                    </SideModal>
                }

                <CreateNewSolicitation
                    loading={loadNewCall}
                    duplicateRow={duplicateRow}
                    templateSelected={templateSelected}
                    show={showCreateSolicitation || openModalPref}
                    handleClose={handleClose}
                />

                {
                    detailsRow &&
                    <SolicitationDetails
                        header={handleHeaderDetails()}
                        visible={modalVisibleDetails && !showCreateSolicitation}
                        onClose={() => setModalVisibleDetails(false)}
                        solicitation={detailsRow}
                        handleCloseReopen={handleCloseReopen}
                        tabMobile={tabMobile}
                        getSolicitationsType={getSolicitationsType}
                    />
                }
                {
                    pendingEvaluation &&
                    <Dialog
                        open={openPopUp}
                        keepMounted
                        onClose={() => setOpenPopUp(false)}
                        aria-describedby={"alert-dialog-slide-description"}
                        className={"dialog"}
                        PaperProps={{
                            style: {
                                display: "flex",
                                backgroundColor: "#FFFFFF",
                                border: "1px solid #4DC77E",
                                boxShadow: "4px 4px 18px rgba(0, 0, 0, 0.25)",
                                width: "328px",
                                height: "80px",
                                alignItems: "flex-end"
                            },
                        }}
                    >
                        <DialogContent
                            style={{
                                padding: "12px 25px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between"
                            }}
                        >
                            <DialogContentText id={"alert-dialog-slide-description"}>
                                Chamado <strong>{pendingEvaluation.id}</strong> encerrado: {pendingEvaluation.subject}
                            </DialogContentText>
                            <span className={"btnDialog"} onClick={() => {
                                handleOpenDetails(pendingEvaluation)
                                setOpenPopUp(false)
                            }}>
                                Avaliar
                            </span>
                        </DialogContent>
                    </Dialog>
                }
            </div>
        </Layout>
    )
}

export default SolicitatonsList;